module.exports = __webpack_public_path__ + "static/media/thumb2-1.ab6b692d.png";